<div *ngIf="isVisible">
    <img alt="truck icon" width="38" height="27" src="../../../../../assets/images/Truck_Icon.png" />
    <div *ngIf="getCostToAddForEligibility() > 0">
        You’re {{getCostToAddForEligibility() | currency}} away from FREE shipping on this order!
    </div>
    <div *ngIf="getCostToAddForEligibility() == 0">
        You are now eligible for free standard shipping!
    </div>
</div>